import { FlashNoticeVariant } from 'components/FlashNotice'
import { showFlashNotice } from 'components/FlashNotice/duck/actions'

import { ScoutingCampaign } from '../../../../../../entities-next/scoutingCampaign'

export function successfulDeleteAlertAction(scoutingCampaign: ScoutingCampaign) {
  return showFlashNotice({
    message: `Space with id ${scoutingCampaign.id} deleted`,
    autoHide: true,
    variant: FlashNoticeVariant.success,
  })
}

export function failedDeleteAlertAction(scoutingCampaign: ScoutingCampaign) {
  return showFlashNotice({
    message: `Space with id ${scoutingCampaign.id} could not be deleted`,
    autoHide: true,
    variant: FlashNoticeVariant.error,
  })
}
